import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Youtube } from 'lucide-react';
import { companyInfo } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="bg-[#1a2f4a]/95 border-t border-blue-800/30">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info with Official Logo */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4">
              <img
                src="/salar-logo-hd.png"
                alt="SALAR Technologies LLC logo"
                className="h-16 md:h-20 w-auto"
                style={{ imageRendering: '-webkit-optimize-contrast' }}
              />
            </div>
            <p className="text-blue-100 text-sm mb-4 max-w-md">
              Engineering-centered capabilities for electronics reliability, semiconductor supply-chain visibility, 
              provenance assurance, and manufacturing stability for defense and strategic industries.
            </p>
            <div className="text-xs text-blue-300/70 space-y-1">
              <p>Oregon LLC • Registry No. {companyInfo.registryNumber}</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/commitment-to-society.html" reloadDocument className="text-blue-100 hover:text-white transition-colors">Commitment to Society</Link></li>
              <li>
                <Link to="/capabilities" className="text-blue-100 hover:text-white transition-colors">
                  Capabilities
                </Link>
              </li>
              <li>
                <Link to="/government-defense" className="text-blue-100 hover:text-white transition-colors">
                  Government & Defense
                </Link>
              </li>
              <li>
                <Link to="/international-procurement" className="text-blue-100 hover:text-white transition-colors">
                  International Procurement
                </Link>
              </li>
              <li>
                <Link to="/patent-portfolio" className="text-blue-100 hover:text-white transition-colors">
                  Patent Portfolio
                </Link>
              </li>
              <li>
                <Link to="/publications" className="text-blue-100 hover:text-white transition-colors">
                  Publications
                </Link>
              </li>
              <li>
                <Link to="/environmental-research" className="text-blue-100 hover:text-white transition-colors">Environmental Research</Link>
              </li>
              <li>
                <Link to="/resources" className="text-blue-100 hover:text-white transition-colors">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/engineering-advancement-medical-science" className="text-blue-100 hover:text-white transition-colors">Medical Science Research</Link>
              </li>
              <li>
                <Link to="/compliance" className="text-blue-100 hover:text-white transition-colors">
                  Compliance & Certifications
                </Link>
              </li>
              <li>
                <Link to="/investor-relations" className="text-blue-100 hover:text-white transition-colors">
                  Investor Relations
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wide">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2 text-blue-100">
                <Mail size={16} className="mt-0.5 flex-shrink-0" />
                <div className="flex flex-col space-y-1">
                  <a href={`mailto:${companyInfo.emails.general}`} className="hover:text-white transition-colors">
                    {companyInfo.emails.general}
                  </a>
                  <a href={`mailto:${companyInfo.emails.direct}`} className="hover:text-white transition-colors">
                    {companyInfo.emails.direct}
                  </a>
                </div>
              </li>
              <li className="flex items-center space-x-2 text-blue-100">
                <Phone size={16} className="flex-shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="hover:text-white transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-start space-x-2 text-blue-100">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" />
                <span>{companyInfo.location}</span>
              </li>
              <li className="flex items-center space-x-2">
                <a 
                  href="https://www.linkedin.com/company/112975340/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-blue-100 hover:text-white transition-colors"
                  aria-label="SALAR Technologies LinkedIn"
                  data-testid="footer-linkedin"
                >
                  <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-[#0A66C2] text-white" aria-hidden="true">
                    <Linkedin size={17} strokeWidth={2.3} />
                  </span>
                  <span>LinkedIn</span>
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <a 
                  href="https://www.youtube.com/@SALARTechnologies"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-blue-100 hover:text-white transition-colors"
                  aria-label="SALAR Technologies YouTube"
                  data-testid="footer-youtube"
                >
                  <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-[#FF0000] text-white" aria-hidden="true">
                    <Youtube size={18} strokeWidth={2.3} />
                  </span>
                  <span>YouTube</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-blue-800/30">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-blue-300/70" data-testid="footer-copyright">
            <p>&copy; 2026 SALAR Technologies LLC. All rights reserved.</p>
            <p className="mt-2 md:mt-0">{companyInfo.domain}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

